import { useState } from 'react';

const useFormPayload = (urlParams) => {
  const [formSubmissionPayload, setFormSubmissionPayload] = useState({ ...urlParams });
  const [pagePayload, setPagePayload] = useState({});
  const [curPageValues, setCurPageValues] = useState({});
  const [changePageValues, setChangePageValues] = useState({});

  /**
   * Refresh form submission payload if click on back button and modify the previous page fields.
   */
  const refreshFormSubmissionPayload = (formDataObj, currentPage) => {
    if (pagePayload[currentPage]) {
      Object.keys(pagePayload[currentPage]).forEach((e) => delete formSubmissionPayload[e]);
    }
    const payloadData = { ...pagePayload };
    payloadData[currentPage] = formDataObj;
    setPagePayload(payloadData);
    return formSubmissionPayload;
  };

  return {
    formSubmissionPayload,
    setFormSubmissionPayload,
    curPageValues,
    setCurPageValues,
    changePageValues,
    setChangePageValues,
    refreshFormSubmissionPayload,
  };
};

export default useFormPayload;
